<template>
  <el-table-column
    prop="tangible_assets_tool.name"
    sortable="custom"
    label="Tárgyi eszközök köre"
    show-overflow-tooltip
    min-width="200"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.tangible_assets_tool">{{ scope.row.tangible_assets_tool.name }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'tangible_assets_tool.name',
  };
</script>
